import * as yup from 'yup';

export const NumberSchema = (): yup.NumberSchema => yup.number()
    .typeError('validation:addTenant.number')
    .integer('validation:addTenant.number')
    .max(1000, 'validation:addTenant.MaxDelay')
export const EmailSchema = (): yup.StringSchema => yup.string()
    .email('validation:addTenant.InvalidEmail')
    .min(5, 'validation:addTenant.InvalidEmail')

export const OnCallTabSchema = (isAdding = false): yup.ObjectSchema<any> => {
    let onCallServiceEmail = yup
        .string()
        .email('validation:addTenant.InvalidEmail');
    let onCallServicePhone = yup
        .string()
        .max(15, 'validation:addTenant.MaxPhone');
    let callRetryDelays = yup.array().nullable().of(NumberSchema()).required("validation:required");

    if (isAdding) {
        onCallServiceEmail = onCallServiceEmail.required('validation:required');
        onCallServicePhone = onCallServicePhone.required('validation:required');
        callRetryDelays = callRetryDelays.min(1, 'validation:required');
    }

    return yup.object().shape({
        onCallServiceEmail,
        onCallServicePhone,
        callRetryDelays,
    })
}

export const MainContactSchema = (isAdding = false): yup.ObjectSchema<any> => {
    let email = yup
        .string()
        .email('validation:addTenant.InvalidEmail');
    let name = yup
        .string()
        .matches(/^[a-zA-Z\s]{0,35}$/, 'validation:addTenant.OnlyLettersAllowed')
        .min(0, 'validation:addTenant.MinTenantName')
        .max(15, 'validation:addTenant.MaxTenatnName');
    let phone = yup
        .string()
        .max(15, 'validation:addTenant.MaxPhone');

    if (isAdding) {
        email = email.required('validation:required');
        name = name.required('validation:required');
        phone = phone.required('validation:required');
    }

    return yup.object().shape({
        email,
        name,
        phone,
    })
}

export const MainContactSchemaFromTenant = (isAdding = false): yup.ObjectSchema<any> => yup.object().shape({
    mainContact: isAdding ? MainContactSchema(isAdding).required('validation:required') : MainContactSchema(isAdding)
})

export const GeneralTabSchema = (isAdding: boolean): yup.ObjectSchema<any> => {
    const mainSchema = yup.object().shape({
        name: yup
            .string()
            .matches(/^[a-zA-Z\s]{0,35}$/, 'validation:addTenant.OnlyLettersAllowed')
            .required('validation:addTenant.RequiredUsername')
            .min(4, 'validation:addTenant.MinUsername')
            .max(15, 'validation:addTenant.MaxUsername'),
        address: yup
            .string()
            .max(25, 'validation:addTenant.MaxAddress'),
        exPostRecipients: yup.array().of(EmailSchema())
    })

    if (isAdding) {
        return mainSchema.concat(yup.object().shape({
            subdomain: yup
                .string()
                .required()
                .matches(/^[a-z\s]+$/, 'validation:addTenant.onlyAlphabets'),
                marketPartnerIDCode: yup
                .string()
                .required('validation:addTenant.RequiredMarketPartnerID')
                .matches(/^\d+$/, 'validation:addTenant.OnlyNumbersAllowed')
                .matches(/^.{13}$/, 'validation:addTenant.Exactly13DigitsRequired'), 
            marketPartnerIDEncoding: yup
                .string()
                .required(),

        }))
    }

    return mainSchema
}

export const TenantDetailsValidation = (isAdding: boolean): yup.ObjectSchema<any> => yup.object().shape({
    mainContact: MainContactSchema(isAdding)
}).concat(GeneralTabSchema(isAdding)).concat(OnCallTabSchema(isAdding))
